<template>
  <v-layout>
    <v-row v-if="loadingCurriculums" class="d-flex">
      <v-col
        v-for="i in 12"
        :key="i"
        cols="4"
      >
        <v-card shaped>
          <v-card-text>
            <v-skeleton-loader type="heading"></v-skeleton-loader>
            <br/>
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </v-card-text>
          <v-card-actions v-if="randomlyApplyChip()">
            <v-spacer></v-spacer>
            <v-skeleton-loader type="chip"></v-skeleton-loader>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else class="d-flex">
      <v-col
        v-for="curriculum in curriculums"
        :key="curriculum.id"
        cols="4"
      >
        <v-card shaped>
          <v-card-title>
            <router-link 
              :to="{ name: 'Curriculum', params: { id: curriculum.id} }"
            >
              {{ curriculum.fields.Name }}
            </router-link>
          </v-card-title>
          <v-card-text>
            {{ curriculum.fields.Description }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-chip v-if="showChip(curriculum)" small>
              {{ getChipText(curriculum) }}
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
  import { CurriculumChip } from '@/mixins/CurriculumChip.js'
  
  export default {
    name: 'List',
    mixins: [CurriculumChip],
    data () {
      return {
        loadingCurriculums: true
      }
    },
    created () {
      this.$store.dispatch('getRecords', {
        table: 'Curriculums',
        view: 'All Curriculums',
        dispatch: 'setCurriculums'
      })
      .then(() => {
        this.loadingCurriculums = false
      })
    },
    computed: {
      curriculums () {
        return this.$store.getters.getCurriculums
      }
    },
    methods: {
      randomlyApplyChip () {
        // get a random number. if its divisible by 2, apply the chip
        return Math.floor(Math.random() *10)%2 === 0
      }
    }
  }
</script>

<style>
  .v-card__text, .v-card__title {
    word-break: normal;
  }
</style>
